import React from 'react'

import {Props} from './types'

const Pin: React.FC<Props> = props => (
  <svg fill="none" height="78" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_d)">
      <path d="M30.0003 57.0001c1.0001-2 2.0001-3.9999 4.9999-4.4999-3.0002-1.5002-7.0002-1.5004-10 0 2.9998.4999 4.0001 2.5 5 4.5l.0001-.0001z" />
      <circle cx="30" cy="28" r="25" />
      <circle cx="30" cy="28" fill="#fff" r="5" />
      <circle cx="30" cy="66" r="4" stroke="#fff" strokeWidth="2" />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="78"
        id="filter0_d"
        width="60"
        x="0"
        y="0"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
)

export default Pin
